module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/39/assets/images/4bb74de0e72316471eaea0c8d98ed6aa.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_all_assigned.svg
// module id = 3TsF
// module chunks = 0